<template>
    <div>
        <data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            class="row-pointer"
            v-sortable-data-table
            @sorted="saveBranchOrder"
        >
            <template v-slot:top>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">
                            Czy na pewno chcesz usunąć ten oddział?
                        </v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="onDeleteDialogClosed">
                                Anuluj
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="onDeleteConfirmed">
                                Tak
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:item.name="{ item }">
                <span v-html="formatEmpty(item.name, 'Brak', 'red--text')"/>
            </template>
            <template v-slot:item.email="{ item }">
                <span v-html="formatEmpty(item.email)"/>
            </template>
            <template v-slot:item.phone="{ item }">
                <span v-html="formatEmpty(item.phone)"/>
            </template>
            <template v-slot:item.address="{ item }">
                <span v-html="extractFullAddress(item.address)"/>
            </template>
            <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, 'Brak') }}
            </template>
            <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, 'Nie modyfikowano') }}
            </template>
            <template v-slot:item.isMain="{ item }">
                <span v-html="formatIsMain(item.isMain)"></span>
            </template>
            <template v-slot:item.actions="{ item }"
                      class="text-end"
            >
                <v-btn
                    class="ma-2"
                    color="blue"
                    dark
                    :disabled="loading"
                    @click="onRowClicked(item, $event)"
                >
                    Edycja
                    <v-icon
                        dark
                        right
                    >
                        mdi-table-edit
                    </v-icon>
                </v-btn>
                <v-btn
                    class="ma-2"
                    color="red"
                    dark
                    :disabled="loading"
                    @click="onDeleteBtnTriggered(item, $event)"
                >
                    Usuń
                    <v-icon
                        dark
                        right
                    >
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
        </data-table>
        <div class="text-center">
            <v-btn
                class="mx-2"
                @click="add"
            >
                Dodaj nowy oddział
            </v-btn>
            <v-btn
                class="mx-2"
                @click="refresh"
            >
                Odśwież
            </v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import {getYesNoName} from '@/enums/YesNo';
import DataTable from "@/components/data-table/DataTable";
import {getName as getRegionName} from '@/enums/RegionCode';
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import Sortable from "sortablejs";

export default {
    props: {
        id: {
            type: [String],
            required: true,
        },
        urlDelete: {
            type: [String],
            required: true,
        },
    },
    mixins: [
        filters,
        formatters,
    ],
    components: {
        DataTable,
    },
    data() {
        return {
            loading: false,
            items: [],
            total: 0,
            options: {},
            headers: [
                {text: 'Nazwa', value: 'name', sortable: false},
                {text: 'Telefon', value: 'phone', sortable: false},
                {text: 'Email', value: 'email', sortable: false},
                {text: 'Adres', value: 'address', sortable: false},
                {text: 'Utworzono', value: 'createdAt', sortable: false},
                {text: 'Ost. modyfikacja', value: 'updatedAt', sortable: false},
                {text: 'Główny', value: 'isMain', sortable: false},
                {text: 'Akcje', value: 'actions', sortable: false},
            ],
            filters: {},
            dialogDelete: false,
            editedIndex: -1,
        };
    },
    directives: {
        sortableDataTable: {
            bind(el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },
    created() {
        getDatatableParams.call(this);
        this.load();
    },
    mounted() {
        const self = this;

        this.$root.$on('loadPriceListCompanyBranches', (options) => {
            self.load(options);
        });
    },
    watch: {
        options: {
            handler() {
                this.load();
                setDatatableOptions.call(this);
            },
            deep: true,
        },
        dialogDelete(value) {
            value || this.onDeleteDialogClosed();
        },
    },
    methods: {
        add() {
            this.$router
                .push({name: 'price-list-company-branch-add', params: {companyId: this.id}})
                .catch(() => {
                });
        },
        appendFilters(params, filters) {
            if (!(filters instanceof Object)) {
                return;
            }

            this.appendStringFilterIfNonEmpty(params, 'branchName', filters.branchName);
        },
        delete(index) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            const item = this.items[index];

            api
                .delete(
                    this.$props.urlDelete.replace('{id}', item.id)
                )
                .then(() => {
                    this.items.splice(index, 1);
                    this.total--;

                    if (!this.items.length) {
                        this.options.page--;
                    }

                    this.onDeleteDialogClosed();
                    this.$root.$emit('notifySuccess', {
                        html: `Oddział został usunięty.`,
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się usunąć oddziału.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.dialogDelete = true;
        },
        extractFullAddress(address) {
            if (null === address) {
                return this.formatEmpty('');
            }

            const street = String(address.address || '').trim();
            const postalCode = String(address.postalCode || '').trim();
            const city = String(address.city || '').trim();
            const region = String(address.region || '').trim();

            const part1 = street;
            const part2 = [postalCode, city].join(' ').trim();
            let part3 = '';

            if ('' !== region) {
                part3 = getRegionName(region) || '';

                if ('' !== part3) {
                    // Encapsulate within "()" but only if second part is not empty.
                    part3 = '' === part2 ? part3 : `(${part3})`;
                }
            }

            let result = [part2, part3].join(' ').trim();

            if ('' !== part1) {
                if ('' === result) {
                    result = part1;
                } else {
                    result = `${part1}, ${result}`;
                }
            }

            return this.formatEmpty(result);
        },
        formatEmpty(value, onEmptyHtml = 'Brak', onEmptyClasses = 'orange--text') {
            if (null !== value && '' !== value) {
                return value;
            }

            return `<em class="${onEmptyClasses}">${onEmptyHtml}</em>`;
        },
        formatIsMain(isMain) {
            const className = isMain ? 'green--text' : 'red--text';
            const text = getYesNoName(isMain);

            return `<span class="${className}">${text}</span>`;
        },
        load(options = {}) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            options = options || {};

            let filters = {};
            this.appendFilters(filters, options.filters || this.filters);
            this.filters = filters; // Remember them.

            const {page, itemsPerPage} = this.options;
            const params = {
                companyId: this.id,
                ...filters,
                offset: page > 1 ? itemsPerPage * (page - 1) : 0,
            };

            if (-1 !== itemsPerPage) {
                params.limit = itemsPerPage;
            }

            api.get(`/api/price-list/company-branch`, {params})
                .then((response) => {
                    this.items = response.data.items;
                    this.total = response.data.total;

                    if (options.onSuccess) {
                        options.onSuccess();
                    }
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać oddziałów.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        refresh() {
            const self = this;
            this.$root.$emit('loadPriceListCompanyBranches', {
                onSuccess: () => {
                    self.$root.$emit('notify', {
                        html: 'Lista została odświeżona.',
                    });
                }
            });
        },
        stopRowClickPropagation(event) {
            // The following line is required to avoid triggering onRowClicked() method.
            event.cancelBubble = true;
            event.stopPropagation();
        },
        onDeleteBtnTriggered(item, event) {
            this.stopRowClickPropagation(event);
            this.deleteItem(item);
        },
        onDeleteConfirmed() {
            this.delete(this.editedIndex);
        },
        onDeleteDialogClosed() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
            });
        },
        onRowClicked(branch) {
            this.$router
                .push({
                    name: 'price-list-company-branch-details',
                    params: {
                        companyId: this.id,
                        id: branch.id
                    },
                })
                .catch(() => {
                });
        },
        saveBranchOrder(event) {
            const movedItem = this.items.splice(event.oldIndex, 1)[0];
            this.items.splice(event.newIndex, 0, movedItem);

            let request = [];

            this.items.forEach((field, index) => {
                request.push({
                    id: field.id,
                    position: index,
                });
            });

            api
                .put('/api/price-list/company-branch/' + this.id + '/position', {branches: request})
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
    },
}
</script>